import React from 'react';
import ReactTooltip from 'react-tooltip';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;


const tagStyle = {
	display: 'inline-block',
	cursor: 'pointer',
};
const textTagStyle = {
	fontWeight: '800',
};

const capsuleTagStyle = {
	color: 'white',
	borderRadius: '20px',
	padding: '2px 10px',
	fontSize: '14px',
	fontWeight: '700',

};

const toolTipStyle = {
	color: 'white',
	padding: '9px 14px',
	maxWidth: '300px',
};

const getTagStyle = (design, color) => {
	if (design === 'capsule') {
		return { ...tagStyle, ...capsuleTagStyle, backgroundColor: color };
	}
	return { ...tagStyle, ...textTagStyle, color };
};
class TextTag extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			id: `tag-${Math.floor(Math.random() * Math.floor(100000))}`,
			tooltipOpen: false,
		};
		this.textTagRef = React.createRef();
	}
	componentDidMount = () => {
		// this.toggle();
	}
	/* UNSAFE_componentWillMount = () => {
		this.setState({
			id: `tag-${Math.floor(Math.random() * Math.floor(100000))}`,
		});
	} */
	toggle = () => {
		this.setState({
			tooltipOpen: !this.state.tooltipOpen,
		});
	}
	render() {
		const {
			name, style, color, className, design, id, showTooltip, tooltip
		} = this.props;
		return (
			<React.Fragment>
				{name && <div className="d-flex f-d-row align-self-center"  data-tip={tooltip} data-place="top" data-for={`tooltip-textTag-${id}`}>
				<p style={{ ...getTagStyle(design, color), ...style,cursor: 'default'  }} className={className} id={id}>
				{this.props.origin && <span className="mr-1">
				<img className=" justify-content-center align-self-center" src={`${config.cdnUrl}/static/icons/program-page/warning.svg`} alt="tag-icon" width={20} height={20}/>
				</span>}
				{name}</p>
				<ReactTooltip  id={`tooltip-textTag-${id}`} ref={this.textTagRef} data-multiline={true} data-event="click"/>
				</div>}
				<style global jsx>
					{ 
						`
						.__react_component_tooltip {
							width: 300px !important;
						}
						`
					} 
				</style>
			</React.Fragment>
		);
	}
}

TextTag.defaultProps = {
	className: 'gi-tag',
};
export default TextTag;
